(function (app) {

    app.provider("firelightSsoApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    service.InitiateFirelightSso = function (transactionId) {
                        return complianceHubApiGateway.post("/FirelightSso/" + transactionId);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line